import { isRestaurantId } from './tenantPath';

// Hints for LegacyRedirect only. The URL selects live-tab tenancy; requests,
// auth context and analytics never consult storage. Failed storage is harmless
// to requests; an in-memory fallback keeps this tab's last hint usable.
export const TENANT_STORAGE_KEY = 'restaurantId';
let unsaved = null;

function readStore(storeName) {
  try {
    const store = window[storeName];
    const stored = store.getItem(TENANT_STORAGE_KEY);
    if (!stored) return null;
    if (isRestaurantId(stored)) return stored;
    store.removeItem(TENANT_STORAGE_KEY);
    return null;
  } catch { return null; } // A missing hint falls through to the user's assignments.
}

function writeStore(storeName, id) {
  try {
    if (id == null) window[storeName].removeItem(TENANT_STORAGE_KEY);
    else window[storeName].setItem(TENANT_STORAGE_KEY, id);
    return true;
  } catch { return false; } // Best effort: storage does not control tenancy.
}

function writeTab(id) {
  unsaved = writeStore('sessionStorage', id) ? null : { id };
}

export const readTabTenant = () => (unsaved ? unsaved.id : readStore('sessionStorage'));
export const readDefaultTenant = () => readStore('localStorage');

// Only URL changes (or session cleanup) write hints. A global URL leaves the
// last restaurant intact so a later legacy handoff can return there.
export function setTabTenant(id) {
  if (id != null && !isRestaurantId(id)) return undefined;
  const next = id == null ? null : String(id);
  writeTab(next);
  writeStore('localStorage', next);
  return next;
}

// Remote logout clears this tab only; the other tab owns the shared hint.
export function clearTabTenant() {
  writeTab(null);
}
